// extracted by mini-css-extract-plugin
export default {"error_container":"PageNotFound_error_container__ap0v4","page_not_found":"PageNotFound_page_not_found__N8Bfw","home_link":"PageNotFound_home_link__w68wA"};